import React, { useState, useMemo } from "react";
import { Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { Input, ProTableOt } from '../ui/ot';
//import HistorySchedule from "./FlexibleScheduling";

const { Content } = Layout;
const { Search } = Input;

const data = [
    // John Doe
    {
        id: 1,
        name: "John Doe",
        employeeNumber: "A001",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 2,
        name: "John Doe",
        employeeNumber: "A001",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 3,
        name: "John Doe",
        employeeNumber: "A001",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Jane Smith
    {
        id: 4,
        name: "Jane Smith",
        employeeNumber: "A002",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 5,
        name: "Jane Smith",
        employeeNumber: "A002",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 6,
        name: "Jane Smith",
        employeeNumber: "A002",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Alice Johnson
    {
        id: 7,
        name: "Alice Johnson",
        employeeNumber: "A003",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 8,
        name: "Alice Johnson",
        employeeNumber: "A003",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 9,
        name: "Alice Johnson",
        employeeNumber: "A003",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Chris Lee
    {
        id: 10,
        name: "Chris Lee",
        employeeNumber: "A004",
        position: "部分兼職",
        workingHours: 30,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 11,
        name: "Chris Lee",
        employeeNumber: "A004",
        position: "部分兼職",
        workingHours: 30,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 12,
        name: "Chris Lee",
        employeeNumber: "A004",
        position: "部分兼職",
        workingHours: 30,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Nancy Brown
    {
        id: 13,
        name: "Nancy Brown",
        employeeNumber: "A005",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 14,
        name: "Nancy Brown",
        employeeNumber: "A005",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 15,
        name: "Nancy Brown",
        employeeNumber: "A005",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Michael Green
    {
        id: 16,
        name: "Michael Green",
        employeeNumber: "A006",
        position: "兼職",
        workingHours: 20,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 17,
        name: "Michael Green",
        employeeNumber: "A006",
        position: "兼職",
        workingHours: 20,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 18,
        name: "Michael Green",
        employeeNumber: "A006",
        position: "兼職",
        workingHours: 20,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Emma White
    {
        id: 19,
        name: "Emma White",
        employeeNumber: "A007",
        position: "部分兼職",
        workingHours: 25,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 20,
        name: "Emma White",
        employeeNumber: "A007",
        position: "部分兼職",
        workingHours: 25,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 21,
        name: "Emma White",
        employeeNumber: "A007",
        position: "部分兼職",
        workingHours: 25,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Oliver Harris
    {
        id: 22,
        name: "Oliver Harris",
        employeeNumber: "A008",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 23,
        name: "Oliver Harris",
        employeeNumber: "A008",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 24,
        name: "Oliver Harris",
        employeeNumber: "A008",
        position: "正職",
        workingHours: 40,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Sophia Clark
    {
        id: 25,
        name: "Sophia Clark",
        employeeNumber: "A009",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 26,
        name: "Sophia Clark",
        employeeNumber: "A009",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 27,
        name: "Sophia Clark",
        employeeNumber: "A009",
        position: "兼職",
        workingHours: 20,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Liam Lewis
    {
        id: 28,
        name: "Liam Lewis",
        employeeNumber: "A010",
        position: "正職",
        workingHours: 40,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 29,
        name: "Liam Lewis",
        employeeNumber: "A010",
        position: "正職",
        workingHours: 40,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 30,
        name: "Liam Lewis",
        employeeNumber: "A010",
        position: "正職",
        workingHours: 40,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Ava Walker
    {
        id: 31,
        name: "Ava Walker",
        employeeNumber: "A011",
        position: "部分兼職",
        workingHours: 30,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 32,
        name: "Ava Walker",
        employeeNumber: "A011",
        position: "部分兼職",
        workingHours: 30,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 33,
        name: "Ava Walker",
        employeeNumber: "A011",
        position: "部分兼職",
        workingHours: 30,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // William Young
    {
        id: 34,
        name: "William Young",
        employeeNumber: "A012",
        position: "正職",
        workingHours: 40,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 35,
        name: "William Young",
        employeeNumber: "A012",
        position: "正職",
        workingHours: 40,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 36,
        name: "William Young",
        employeeNumber: "A012",
        position: "正職",
        workingHours: 40,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Mia King
    {
        id: 37,
        name: "Mia King",
        employeeNumber: "A013",
        position: "兼職",
        workingHours: 20,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 38,
        name: "Mia King",
        employeeNumber: "A013",
        position: "兼職",
        workingHours: 20,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 39,
        name: "Mia King",
        employeeNumber: "A013",
        position: "兼職",
        workingHours: 20,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // James Scott
    {
        id: 40,
        name: "James Scott",
        employeeNumber: "A014",
        position: "部分兼職",
        workingHours: 35,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 41,
        name: "James Scott",
        employeeNumber: "A014",
        position: "部分兼職",
        workingHours: 35,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 42,
        name: "James Scott",
        employeeNumber: "A014",
        position: "部分兼職",
        workingHours: 35,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Ella Adams
    {
        id: 43,
        name: "Ella Adams",
        employeeNumber: "A015",
        position: "正職",
        workingHours: 40,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 44,
        name: "Ella Adams",
        employeeNumber: "A015",
        position: "正職",
        workingHours: 40,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 45,
        name: "Ella Adams",
        employeeNumber: "A015",
        position: "正職",
        workingHours: 40,
        description: "Designer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Lucas Baker
    {
        id: 46,
        name: "Lucas Baker",
        employeeNumber: "A016",
        position: "兼職",
        workingHours: 20,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 47,
        name: "Lucas Baker",
        employeeNumber: "A016",
        position: "兼職",
        workingHours: 20,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 48,
        name: "Lucas Baker",
        employeeNumber: "A016",
        position: "兼職",
        workingHours: 20,
        description: "Analyst",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Amelia Carter
    {
        id: 49,
        name: "Amelia Carter",
        employeeNumber: "A017",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 50,
        name: "Amelia Carter",
        employeeNumber: "A017",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 51,
        name: "Amelia Carter",
        employeeNumber: "A017",
        position: "正職",
        workingHours: 40,
        description: "Tester",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Henry Perez
    {
        id: 52,
        name: "Henry Perez",
        employeeNumber: "A018",
        position: "部分兼職",
        workingHours: 30,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 53,
        name: "Henry Perez",
        employeeNumber: "A018",
        position: "部分兼職",
        workingHours: 30,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 54,
        name: "Henry Perez",
        employeeNumber: "A018",
        position: "部分兼職",
        workingHours: 30,
        description: "Support",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Isabella Turner
    {
        id: 55,
        name: "Isabella Turner",
        employeeNumber: "A019",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 56,
        name: "Isabella Turner",
        employeeNumber: "A019",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 57,
        name: "Isabella Turner",
        employeeNumber: "A019",
        position: "正職",
        workingHours: 40,
        description: "Developer",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },

    // Jack Roberts
    {
        id: 58,
        name: "Jack Roberts",
        employeeNumber: "A020",
        position: "兼職",
        workingHours: 20,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/04 10:00",
        startTime: "2024/08/04 9:00",
        endTime: "2024/08/04 18:00",
    },
    {
        id: 59,
        name: "Jack Roberts",
        employeeNumber: "A020",
        position: "兼職",
        workingHours: 20,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/05 10:00",
        startTime: "2024/08/05 9:00",
        endTime: "2024/08/05 18:00",
    },
    {
        id: 60,
        name: "Jack Roberts",
        employeeNumber: "A020",
        position: "兼職",
        workingHours: 20,
        description: "Manager",
        changed: false,
        modifiedTime: "2024/08/06 10:00",
        startTime: "2024/08/06 9:00",
        endTime: "2024/08/06 18:00",
    },
];

const HistorySchedule = () => {
    const [filteredData, setFilteredData] = useState(data);
    const [searchSuggestions, setSearchSuggestions] = useState([]);
    const navigate = useNavigate();

    const onSearch = (value) => {
        const filtered = data.filter(
            (item) =>
                item.name.includes(value) ||
                item.employeeNumber.includes(value) ||
                item.position.includes(value)
        );
        setFilteredData(filtered);
    };

    const onChange = (e) => {
        const value = e.target.value;
        const suggestions = data.filter(
            (item) =>
                item.name.includes(value) ||
                item.employeeNumber.includes(value) ||
                item.position.includes(value)
        );
        setSearchSuggestions(suggestions);
    };

    const columns = useMemo(
        () => [
            {
                title: "編號",
                dataIndex: "id",
                key: "id",
            },
            {
                title: "員工名",
                dataIndex: "name",
                key: "name",
                sorter: (a, b) => a.name.localeCompare(b.name),
            },
            {
                title: "工號",
                dataIndex: "employeeNumber",
                key: "employeeNumber",
            },
            {
                title: "職位",
                dataIndex: "position",
                key: "position",
            },
            {
                title: "工作時數",
                dataIndex: "workingHours",
                key: "workingHours",
            },
            {
                title: "描述",
                dataIndex: "description",
                key: "description",
            },
            {
                title: "修改時間",
                dataIndex: "modifiedTime",
                key: "modifiedTime",
            },
            {
                title: "開始時間",
                dataIndex: "startTime",
                key: "startTime",
            },
            {
                title: "結束時間",
                dataIndex: "endTime",
                key: "endTime",
            },
        ],
        []
    );

    return (
        <Content>
            <ProTableOt
                columns={columns}
                request={async (params) => {
                    const filteredData = data.filter(
                        (item) =>
                            item.name.includes(params.keyword || "") ||
                            item.employeeNumber.includes(params.keyword || "")
                    );
                    const currentPage = params.current || 1;
                    const pageSize = params.pageSize || 10;
                    const startIndex = (currentPage - 1) * pageSize;
                    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
                    return {
                        data: paginatedData,
                        success: true,
                        total: filteredData.length,
                    };
                }}
                rowKey="id"
                pagination={{ pageSize: 10 }}
                search={false}
            />
        </Content>
    );
};

export default HistorySchedule;
